import { isSelectorValid } from '../element-helper.js';
import { ensureArray } from '../primitives/index.js';

/**
 * search for first valid querySelector leading to valid HTMLElement in an array of selectors.
 * Valid selectors might still result in no elements found.
 * Should no element be findable, return last valid selector that resulted in null.
 *
 * @param queries - multiple querySelectors as array
 * @param targetWin - optional target window, make searching in other window objects possible.
 * @returns {{node: HTMLElement | null, selector: string}}
 */
export const findFirstMatchingQuery = (queries: string[] | string, targetWin: Window = window): { node: HTMLElement | null, selector: string } => {
    let node: HTMLElement | null = null;
    let selector = '';
    for (const query of ensureArray(queries)) {
        if (isSelectorValid(query)) {
            selector = query;
            node = targetWin.document.querySelector(query);
            // stop search if element is found
            if (node !== null) {
                break;
            }
        }
    }
    return {
        node,
        selector,
    };
};
